module.exports = __webpack_public_path__ + "img/guardian_insatiable_thirst.4b60c943.png";